import React from 'react';
import loadingStyle from '../LoadingOverlay.module.css';

const Overlay = ({children}) => (

    <div className={loadingStyle.overlay}>
        {children}
    </div>
)

export default Overlay;
